export default "__VITE_ASSET__DzH0ifPs__"